import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteCategoryApi,
  getCategoryListApi,
  manageCategoryApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import {
  CategoryData,
  GetCategoryListApiArgs,
  ManageCategoryArgs,
} from "types/category.api";
import { ErrorHandler, SuccessToast } from "utils/toast";

export const getCategories = createAsyncThunk<
  ApiResponse<PaginatedPayload<CategoryData>>, // return type
  GetCategoryListApiArgs | undefined, // argument type
  { rejectValue: string } // rejected type
>("categories/getCategories", async (params, { rejectWithValue }) => {
  try {
    const response = await getCategoryListApi(params);
    console.log(response);
    return response;
  } catch (err: any) {
    console.log(err);
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const deleteCategory = createAsyncThunk<
  ApiResponse<number>, // return type
  number, // argument type
  { rejectValue: string } // rejected type
>("categories/deleteCategory", async (categoryId, { rejectWithValue }) => {
  try {
    const response = await deleteCategoryApi(categoryId);
    response.payload = categoryId;
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to delete");
  }
});

export const manageCategory = createAsyncThunk<
  ApiResponse<CategoryData>, // return type
  ManageCategoryArgs, // argument type
  { rejectValue: string } // rejected type
>("categories/manageCategories", async (params, { rejectWithValue }) => {
  try {
    const response = await manageCategoryApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    ErrorHandler(err);
    return rejectWithValue(err?.message || "Failed to manage");
  }
});
